module.exports = __webpack_public_path__ + "img/Alif Multifinance Syariah.6a141ec1.png";